import api from './api'

// Get all project expenses with pagination and filters
export const getAllProjectExpenses = async (params = {}) => {
  try {
    const response = await api.get('/project-expenses', { params })
    return response.data
  } catch (error) {
    console.error('Error fetching project expenses:', error)
    throw error
  }
}

// Get project expense by ID
export const getProjectExpenseById = async (id) => {
  try {
    const response = await api.get(`/project-expenses/${id}`)
    return response.data
  } catch (error) {
    console.error('Error fetching project expense:', error)
    throw error
  }
}

// Create new project expense
export const createProjectExpense = async (expenseData) => {
  try {
    const response = await api.post('/project-expenses', expenseData)
    return response.data
  } catch (error) {
    console.error('Error creating project expense:', error)
    throw error
  }
}

// Update project expense
export const updateProjectExpense = async (id, expenseData) => {
  try {
    const response = await api.put(`/project-expenses/${id}`, expenseData)
    return response.data
  } catch (error) {
    console.error('Error updating project expense:', error)
    throw error
  }
}

// Delete project expense
export const deleteProjectExpense = async (id) => {
  try {
    const response = await api.delete(`/project-expenses/${id}`)
    return response.data
  } catch (error) {
    console.error('Error deleting project expense:', error)
    throw error
  }
}

// Get project expense statistics
export const getProjectExpenseStats = async (params = {}) => {
  try {
    const response = await api.get('/project-expenses/stats', { params })
    return response.data
  } catch (error) {
    console.error('Error fetching project expense stats:', error)
    throw error
  }
}

const projectExpenseService = {
  getAllProjectExpenses,
  getProjectExpenseById,
  createProjectExpense,
  updateProjectExpense,
  deleteProjectExpense,
  getProjectExpenseStats
}

export default projectExpenseService

